import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Home from './pages/Home';
import Podcast from './pages/Podcast';
import Contact from './pages/Contact';
import Merchandise from './pages/Merchandise';
import About from './pages/About';
import BeOurGuest from './pages/BeOurGuest';
import Community from './pages/Community';
import Press from './pages/Press';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="flex">
          <Sidebar />
          <main className="flex-1 ml-64">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/podcast" element={<Podcast />} />
              <Route path="/about" element={<About />} />
              <Route path="/merchandise" element={<Merchandise />} />
              <Route path="/be-our-guest" element={<BeOurGuest />} />
              <Route path="/community" element={<Community />} />
              <Route path="/press" element={<Press />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
        </div>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;